module.exports = __webpack_public_path__ + "static/media/speedo-meter.9f39effe.svg";